import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import Slider from '../Components/SliderSample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import add from '../Images/add-square.png';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  
  const handleShopNowClick = () => {
    // Navigate to the SampleProducts page and pass the product ID
    navigate(`/SampleProducts`, { state: { productId: product.id, name: product.name, description: product.description, banner: product.banner, image: product.image } });
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col items-start bg-white rounded-lg shadow-lg mx-2 my-2 cursor-pointer" onClick={handleShopNowClick}>
      <div className="w-full">
        <img src={product.image} alt={product.name} className="w-full h-auto object-cover mb-4" />
      </div>
      <div className="text-start pl-5">
        <h3 className="text-md mb-2" style={{ fontFamily: 'arial' }}>{product.name}</h3>
        <p className="text-xs mr-2 mb-7" style={{ fontFamily: 'arial', color: '#8C8C8C' }}> {product.description} </p>
        <div className="flex flex-row items-center justify-between mb-5 gap-20">
          <p className=" " style={{ fontFamily: 'arial', fontSize: '13px' }}>£{product.price}</p>
          <div className="flex flex-row items-center gap-2">
            <p className="" style={{ color: '#EC008C', fontFamily: 'arial', fontSize: '13px' }}>
              Shop Now
            </p>
            <button>
              <img src={add} className="w-4 h-4 mr-2" alt="Add" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CollectionPage = () => {
  const [products, setProducts] = useState([]);
  const location = useLocation();
  const promoBannerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    axios.get('https://backend.printtrio.co.uk/api/free-sample/get-free-sample')
      .then(response => {
        if (response.data.success) {
          setProducts(response.data.data);
        }
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      }) .finally(() => {
        setIsLoading(false); // ✅ Spinner will stop in all cases
      });
  }, []);

  useEffect(() => {
    if (location.state?.scrollToPromo && promoBannerRef.current) {
      window.scrollTo({
        top: promoBannerRef.current.offsetTop,
        behavior: 'smooth',
      });
    }
  }, [location]);

  return (
    <div>
      <div ref={promoBannerRef}>
        <PromoBanner />
      </div>
      <Navbar />
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          {/* Tailwind simple spinner */}
          <svg
            className="animate-spin h-12 w-12 text-pink-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            />
          </svg>
        </div>
      ) : (
        <>
      <Slider />
      <div className="flex flex-col bg-gray-100 py-12 px-2 md:px-16 xl:px-48 max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
        <div className="relative mt-10">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
            {products.map((product) => (
              <div key={product.id}>
                <ProductCard product={product} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Subscribe />
      <FixedImageMessage />
      <Footer />
      </>
      )}
    </div>
  );
};

export default CollectionPage;
